// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip__Tooltip__kn47e"};